
//import {db, functions} from "@/scripts/firebase";
import {FreeBusyStatus, PostStatus, SchedulingEntry, SchedulingSheet, UserRelationship} from "@/common-datatypes";
import { Component,Mixins,Prop,Watch } from "vue-property-decorator"
import {query, Unsubscribe, getDoc, where, getDocs} from 'firebase/firestore'
import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'
import { NoticeProps, UserSentMessage } from "@/scripts/datatypes";

@Component({
  components: {
  }
})

export default class SchedulingUserEntry extends Mixins(Common) {
  @Prop({type: String, default: ''}) private schedulingSheetId?: string
  @Prop({type: String, default: ''}) private entryUser?: string

  observers: (Unsubscribe | undefined)[] = []

  schedulingSheet = {} as SchedulingSheet

  receiverUserIds: string[] = []

  receiverMeta: UserSentMessage['receiverMeta'] = {}

  schedulingEntries: SchedulingEntry[] = []

  reply: {[key: number]: FreeBusyStatus} = {}

  isLoading = false

  comment = ''


  postStatus: PostStatus = 'draft'

  freeBusyStatus = [
    { value: 'free',
      icon: this.$t('freeBusyStatus.free.icon'),
      text: this.$t('freeBusyStatus.free.text')
    },
    { value: 'busy',
      icon: this.$t('freeBusyStatus.busy.icon'),
      text: this.$t('freeBusyStatus.busy.text')
    },
    { value: 'pending',
      icon: this.$t('freeBusyStatus.pending.icon'),
      text: this.$t('freeBusyStatus.pending.text')
    },
  ]

  selectedEntryUser = ''

  notice = {} as NoticeProps

  get disabledSchedulingEntry(){
    return Object.values(this.reply).every((value) => {
      return value === null
    })
  }

  $refs!: {
    validationObserver: InstanceType<typeof ValidationObserver>;
  }


  @Watch('selectedEntryUser')
  resetUserReply(userId: string){
    const entry = this.schedulingEntries.find((entry) => {return entry.userId === userId})
    if(entry){
      if(entry.reply){
        entry.reply.forEach((r) => {
          const time = r.value.getTime()
          this.reply = {
            ...this.reply,
            [time]: r.status
          }
        })
      }
      
      this.comment = entry.comment
      this.postStatus = entry.postStatus
    }
  }

  get entryUsers() {
    const users = [
      {
        userId: this.$store.getters.userId as string,
        ref: this.$getUserPublicProfileDocRef(),
        firstName: this.$store.state.userPublicProfile.firstName as string,
        lastName: this.$store.state.userPublicProfile.lastName as string,
        firstNameYomigana: this.$store.state.userPublicProfile.firstNameYomigana as string,
        lastNameYomigana: this.$store.state.userPublicProfile.lastNameYomigana as string,
      }
    ]

    this.myChildren.forEach((child) => {
      const userRelationship = this.$store.state.userRelationship as UserRelationship
      const meta = userRelationship.familyMeta ? userRelationship.familyMeta[child as keyof UserRelationship['familyMeta']] : undefined

      if(meta){
        users.push({
          ...meta,
          userId: child,
          ref: this.$getUserPublicProfileDocRef(child),
        })
      }
    })

    return users.map((user) => {
      return {
        ...user,
        name: this.$t('text.name',{lastName: user.lastName,firstName: user.firstName})
      }
    })
  }

  postStatuses(){
    if(this.$te('event.postStatus')){
      const statuses = this.$t('event.postStatus') as unknown as {[K in PostStatus]: string}
      return statuses
    }
    return undefined
  }

  getReply(date: Date){
    const time = date.getTime()
    return this.reply[time] || null
  }

  get myChildren(){
    return this.$store.getters.myChildren as Array<string>
  }

  setStatus(status: FreeBusyStatus, date: Date){
    const time = date.getTime()    
    this.reply = {
      ...this.reply,
      [time]: status
    }
  }

  async saveSchedulingEntry(){
		try{
			this.notice = {
				isShow: false,
			}

      const entryData = this.schedulingEntries.find((entry) => {return entry.userId === this.selectedEntryUser})

      console.log(entryData)

      if(entryData && await this.$refs.validationObserver.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true

        const entryReply: SchedulingEntry['reply'] = Object.keys(this.reply).map((key) => {
          const time = Number.parseInt(key)
          const date = new Date(time)
          const status = this.reply[time]
          return {
            value: date,
            status: status
          }
        }) 

        const data: SchedulingEntry = {
          ...entryData,
          reply: entryReply,
          comment: this.comment,
          postStatus: this.postStatus
        }

        const docId = data.docId

        if(docId){//update
          await this.$updateDoc(this.$getSchedulingEntryDocRef(docId),data)
        }else{//create
          await this.$createDoc(this.$getSchedulingEntriesColRef(),data)
        }

        this.notice = {
          message: this.$t('addScheduling.success') as string,
          isShow: true,
          duration: 0,
          type: {'is-success': true}
        }

        this.loadData()

        this.$nextTick(() =>{
          this.$refs.validationObserver.reset()
        })
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('addScheduling.error') as string
      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
			
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }


  mounted(){
    console.log('mounted')
  }

  async loadData(){
      if(this.schedulingSheetId){
        const schedulingSheetDocRef = this.$getSchedulingSheetDocRef(this.schedulingSheetId)
        const schedulingSheetDoc = await getDoc(schedulingSheetDocRef)

        if(schedulingSheetDoc.exists()){
          this.schedulingSheet = {
            ...schedulingSheetDoc.data() as SchedulingSheet,
          }

          this.schedulingEntries = this.entryUsers.map((entryUser) => {
            const reply = this.schedulingSheet.proposedDates.map((date) => {
              return {
                value: date.value,
                status: null
              }
            })

            const data = {
              docId: '',
              start: this.schedulingSheet.start,
              end:  this.schedulingSheet.end,
              sheetId: this.schedulingSheet.docId,
              sheetRef: schedulingSheetDocRef,
              reply: reply,
              userId: entryUser.userId,
              userMeta: {
                ref: entryUser.ref,
                firstName: entryUser.firstName,
                lastName: entryUser.lastName,
                firstNameYomigana: entryUser.firstNameYomigana,
                lastNameYomigana: entryUser.lastNameYomigana
              },
              schoolId: this.$store.getters.schoolId as string,
              comment: '',
              postStatus: 'draft'
            } as SchedulingEntry
            
            return data
          })

          const schedulingEntryQuery = query(this.$getUserSchedulingEntriesQuery(),where('sheetId','==',schedulingSheetDoc.id))

          const userSchedulingEntryDocs = await getDocs(schedulingEntryQuery)

        
          userSchedulingEntryDocs.forEach((doc) => {
            let data = {
              ...doc.data(),
              docId: doc.id,
            } as SchedulingEntry

            const reply = this.schedulingSheet.proposedDates.map((date) => {
              const r = data.reply.find((r) => {return date.value.getTime() === r.value.getTime()})
              if(r){
                return r
              }
              return {
                value: date.value,
                status: null
              }
            })

            data = {
              ...data,
              reply: reply
            }
            
            const findIndex = this.schedulingEntries.findIndex(entry => {return entry.userId === data.userId})

            const deleteCount = (findIndex === -1 ? 0 : 1)
            this.schedulingEntries.splice(findIndex,deleteCount,data)
          })

          this.resetUserReply(this.selectedEntryUser)
        }
      }
  }
 
  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{
      this.selectedEntryUser = (this.entryUser && this.entryUsers.find((entryUser) => {return entryUser.userId === this.entryUser}) ? this.entryUser : (this.myChildren.length > 0 ? this.myChildren[0] :  this.$store.getters.userId) )

      await this.loadData()

    }catch(error){
      console.log(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
 
  destroyed() {
    console.trace('destroyed')
    this.$unsubscriber(this.observers)
  }

  get isStaff(){
    return this.$store.getters.isStaff as boolean
  }

}
